module.exports = __webpack_public_path__ + "img/ribbon2.00aef365.png";